import {
	shortenedAndUnshortened
} from 'scoreboard/initiatives/format-initiative-calculations'

/**
 * Returns formatter functions for the given initiative settings.
 *
 * @param {Object} initiative - the initiative that the data comes from
 * @param {InitiativeCalculationType} dataProperty - the calculation to use for the data
 * @param {any} precision - the precision to use when formatting the value
 * @returns {{shortened: Function, unshorted: Function}} function that returns
 * two formatter functions, one for a "shortened" value (eg "24K") and one for
 * an "unshortened" value (eg "24,000")
 */
function initiativeFormatter (initiative, dataProperty, precision = null) {
	return shortenedAndUnshortened(
		dataProperty, { currencyCode: initiative.currencyCode, precision })
}

export default initiativeFormatter

initiativeFormatter.__filename__ = 'charts/chart-data/initiative-formatter.js'
